import { render, staticRenderFns } from "./PhotoViewer.vue?vue&type=template&id=3fe095b3&scoped=true&"
import script from "./PhotoViewer.vue?vue&type=script&lang=js&"
export * from "./PhotoViewer.vue?vue&type=script&lang=js&"
import style0 from "./PhotoViewer.vue?vue&type=style&index=0&id=3fe095b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe095b3",
  null
  
)

component.options.__file = "PhotoViewer.vue"
export default component.exports